export const paymentConstants = {
    PAYMENT_DATA_REQUEST: 'PAYMENT_DATA_REQUEST',
    PAYMENT_DATA_SUCCESS: 'PAYMENT_DATA_SUCCESS',
    PAYMENT_DATA_FAILURE: 'PAYMENT_DATA_FAILURE'
};